var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noSelect",attrs:{"id":"app"}},[_c('Header'),_c('router-view',{style:(_vm.styleObj)}),_c('Footer'),_c('Modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.modalShow),expression:"modalShow"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }